import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PostCard from '../components/ui/PostCard';

export default function ProfilPublic() {
  const { username } = useParams();
  const { user: currentUser } = useAuth();
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [posts, setPosts] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [activeTab, setActiveTab] = useState('actus');
  const [friendStatus, setFriendStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('mjtoken');
  const [reported, setReported] = useState(false);

  useEffect(() => {
    fetch('/api/auth/user/' + username)
      .then(r => r.json())
      .then(data => { setMember(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [username]);

  useEffect(() => {
    if (!member) return;
    try { if (JSON.parse(localStorage.getItem('mjreported') || '[]').includes(member._id)) setReported(true); } catch {}
    fetch('/api/posts/user/' + member._id, { headers: token ? { Authorization: 'Bearer ' + token } : {} })
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setPosts(data); }).catch(() => {});
    fetch('/api/testimonials/user/' + member._id)
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setTestimonials(data); }).catch(() => {});
    if (token && currentUser) {
      fetch('/api/friends/mine', { headers: { Authorization: 'Bearer ' + token } })
        .then(r => r.json()).then(data => {
          if (data.accepted?.some(f => f.user._id === member._id)) setFriendStatus('accepted');
          else if (data.sent?.some(f => f.userId === member._id || f.userId?.toString() === member._id)) setFriendStatus('sent');
          else if (data.pending?.some(f => f.user._id === member._id)) setFriendStatus('pending');
          else setFriendStatus('none');
        }).catch(() => {});
    }
  }, [member]);

  const handleAddFriend = async () => {
    if (!token) return navigate('/connexion');
    await fetch('/api/friends/request/' + member._id, { method: 'POST', headers: { Authorization: 'Bearer ' + token } });
    setFriendStatus('sent');
  };

  const handleMessage = async () => {
    if (!token) return navigate('/connexion');
    const res = await fetch('/api/messages/conversations/' + member._id, { method: 'POST', headers: { Authorization: 'Bearer ' + token } });
    if (res.ok) navigate('/profil?tab=messages');
  };

  const handleReport = async () => {
    if (!token) return navigate('/connexion');
    if (reported) return;
    if (!window.confirm('Signaler ce membre ?')) return;
    try {
      const res = await fetch('/api/reports', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ targetType: 'membre', targetId: member._id, targetLabel: member.username })
      });
      if (!res.ok) { alert("Signalement impossible, reessayez."); return; }
      try { const a = JSON.parse(localStorage.getItem('mjreported') || '[]'); if (!a.includes(member._id)) { a.push(member._id); localStorage.setItem('mjreported', JSON.stringify(a)); } } catch {} setReported(true);
    } catch { alert("Signalement impossible, reessayez."); }
  };

  const isOwnProfile = currentUser?.username === username;
  const initiales = (member?.username || 'U').slice(0,2).toUpperCase();
  const sectionLabel = { scene: 'Sur scene', rencontre: 'Rencontres', etsi: 'Et si...', art: 'Art', documentaire: 'Documentaire', photos: 'Photos rares' };

  if (loading) return <div style={{ padding: '4rem', textAlign: 'center', color: '#9a8080' }}>Chargement...</div>;
  if (!member) return <div style={{ padding: '4rem', textAlign: 'center', color: '#9a8080' }}>Membre non trouve.</div>;

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', fontFamily: 'Arial,sans-serif' }}>
      <div style={{ background: 'linear-gradient(135deg,#1a1010,#2a1518)', padding: '32px 40px', display: 'flex', alignItems: 'center', gap: '24px' }}>
        <div style={{ width: 80, height: 80, borderRadius: '50%', border: '3px solid #8b1a2a', overflow: 'hidden', background: '#f5eeeb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700, color: '#8b1a2a', flexShrink: 0 }}>
          {member.photo ? <img src={member.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initiales}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 22, color: '#fff', marginBottom: 4 }}>{member.username}</div>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>
            {[member.country, member.ville, member.age ? member.age + ' ans' : null, member.fanSince ? 'Fan depuis ' + member.fanSince : null].filter(Boolean).join(' · ')}
          </div>
          {member.tags?.length > 0 && (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {member.tags.map(t => <span key={t} style={{ fontSize: 12, background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.7)', padding: '3px 10px', borderRadius: 10 }}>{t}</span>)}
            </div>
          )}
        </div>
        {!isOwnProfile && (
          <div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
            {friendStatus === 'none' && (
              <button onClick={handleAddFriend} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>+ Ajouter en ami</button>
            )}
            {friendStatus === 'sent' && (
              <button disabled style={{ background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.5)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '9px 18px', fontSize: 13, cursor: 'default' }}>Demande envoyee</button>
            )}
            {friendStatus === 'accepted' && (
              <button disabled style={{ background: 'rgba(255,255,255,0.1)', color: '#e8a0a0', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '9px 18px', fontSize: 13, cursor: 'default' }}>Amis</button>
            )}
            {friendStatus === 'pending' && (
              <button disabled style={{ background: 'rgba(255,255,255,0.1)', color: '#e8a0a0', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '9px 18px', fontSize: 13, cursor: 'default' }}>Demande recue</button>
            )}
            <button onClick={handleMessage} style={{ background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '9px 18px', fontSize: 13, cursor: 'pointer' }}>Envoyer un message</button>
            {token && (reported
              ? <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', textAlign: 'center', display: 'block', marginTop: 2 }}>Signalé</span>
              : <span onClick={handleReport} style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', cursor: 'pointer', textAlign: 'center', display: 'block', marginTop: 2 }}>⚑ Signaler ce membre</span>)}
          </div>
        )}
        {isOwnProfile && (
          <button onClick={() => navigate('/profil')} style={{ background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '9px 18px', fontSize: 13, cursor: 'pointer' }}>Mon profil →</button>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', background: '#fff', borderBottom: '2px solid #c49090' }}>
        {[
          { n: posts.length, l: 'actus' },
          { n: testimonials.length, l: 'temoignages' },
          { n: member.ville || member.country || '', l: 'localisation' },
          { n: new Date(member.createdAt).getFullYear(), l: 'membre depuis' }
        ].map((s, i) => (
          <div key={i} style={{ padding: '18px', textAlign: 'center', borderRight: i < 3 ? '1px solid #dccfc8' : 'none' }}>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 22, color: '#8b1a2a' }}>{s.n}</div>
            <div style={{ fontSize: 12, color: '#9a8080', marginTop: 3 }}>{s.l}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid #e8d0d0', background: '#fff', padding: '0 40px' }}>
        {[{ key: 'actus', label: 'Actus' }, { key: 'temoignages', label: 'Temoignages' }].map(t => (
          <div key={t.key} onClick={() => setActiveTab(t.key)}
            style={{ padding: '14px 20px', fontSize: 13, color: activeTab === t.key ? '#8b1a2a' : '#9a8080', cursor: 'pointer', borderBottom: activeTab === t.key ? '2px solid #8b1a2a' : '2px solid transparent', fontWeight: activeTab === t.key ? 600 : 400 }}>
            {t.label}
          </div>
        ))}
      </div>

      <div style={{ padding: '24px 40px', maxWidth: 720 }}>
        {member.bio && (
          <div style={{ fontSize: 14, color: '#4a3030', lineHeight: 1.7, fontStyle: 'italic', fontFamily: 'Georgia,serif', background: '#fff', border: '1px solid #e8d0d0', borderRadius: 10, padding: 16, marginBottom: 20 }}>
            "{member.bio}"
          </div>
        )}

        {activeTab === 'actus' && (
          posts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#9a8080', fontSize: 13, fontStyle: 'italic' }}>Aucune actu publiee.</div>
          ) : (
            posts.map(post => (
              <PostCard key={post._id} post={post} currentUserId={currentUser?._id || currentUser?.id}
                token={token}
                onUpdate={() => {}}
                onDelete={() => {}} />
            ))
          )
        )}

        {activeTab === 'temoignages' && (
          testimonials.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#9a8080', fontSize: 13, fontStyle: 'italic' }}>Aucun temoignage publie.</div>
          ) : (
            testimonials.map(t => (
              <div key={t._id} style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 10, padding: 16, marginBottom: 10 }}>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
                  <span style={{ fontSize: 12, background: '#f5eeeb', color: '#8b1a2a', padding: '2px 8px', borderRadius: 4, border: '1px solid #c49090' }}>{sectionLabel[t.section] || t.section}</span>
                  {t.eventName && <span style={{ fontSize: 12, color: '#9a8080' }}>{t.eventName}</span>}
                </div>
                <p style={{ fontSize: 13, color: '#1a1010', lineHeight: 1.7, fontStyle: 'italic', fontFamily: 'Georgia,serif' }}>"{t.content}"</p>
              </div>
            ))
          )
        )}
      </div>
    </div>
  );
}
